import {
  UpdateBookingPatientInfo,
  UpdateBookingInfo,
  ActionType,
  BookingState,
  ClearBookingInfo,
  SelectAvailability,
  LuxonFormats,
  RecursivePartial,
  PatientChartInfo,
} from 'types';
import { DateTime, Settings } from 'luxon';

export const updateBookingPatientInfo = (
  patient: Partial<PatientChartInfo>,
): UpdateBookingPatientInfo => ({
  payload: { patient },
  type: ActionType.UpdateBookingPatientInfo,
});

export const updateBookingInfo = (booking: RecursivePartial<BookingState>): UpdateBookingInfo => ({
  payload: booking,
  type: ActionType.UpdateBookingInfo,
});

export const clearBookingInfo = (): ClearBookingInfo => ({
  type: ActionType.ClearBookingInfo,
});

export const selectAvailability: SelectAvailability =
  (date, time, appointmentTypeId, serviceLocationId, physicianId) =>
  (dispatch, getState): void => {
    const state = getState();
    const firstAvailablePhysicianId =
      state.entities.availabilities?.[appointmentTypeId][date][time][0];

    dispatch(
      updateBookingInfo({
        appointmentTypeId,
        physicianId: physicianId || firstAvailablePhysicianId,
        scheduledDate: DateTime.fromFormat(
          `${date}, ${time}`,
          `${LuxonFormats.ServerDate}, HH:mm`,
          {
            zone: Settings.defaultZone,
          },
        ).toISO(),
        selectedServiceLocationId: serviceLocationId,
      }),
    );
  };
